import { useEffect, useState } from "react";
import { t } from "i18next";
import { Tag, Tooltip, Button, Modal } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import DataGrid from "../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";

export default function SmsLogDataGrid() {
    const { queryModel, setDataGridProps, setData, setPaginationResult } = useDataGrid();
    // The selected log row whose full provider response is shown in the modal (null = modal closed).
    const [detailRow, setDetailRow] = useState(null);

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                {
                    dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), sorter: true, width: 160,
                    render: (val) => Helper.Date.dateFormat(val)
                },
                { dataIndex: 'phoneNumber', key: 'phoneNumber', title: t('Phone'), width: 140, render: (val) => val || '-' },
                {
                    dataIndex: 'recipientName', key: 'recipientName', title: t('Recipient'), width: 180,
                    render: (val, row) => val || row.user?.name || '-'
                },
                { dataIndex: 'senderName', key: 'senderName', title: t('Sender'), width: 140, render: (val) => val || '-' },
                { dataIndex: 'type', key: 'type', title: t('Type'), width: 120, render: (val) => val || '-' },
                { dataIndex: 'service', key: 'service', title: t('Service'), width: 110, render: (val) => val || '-' },
                {
                    dataIndex: 'message', key: 'message', title: t('Message'), width: 320,
                    render: (val) => val
                        ? (
                            <Tooltip title={<span style={{ whiteSpace: 'pre-wrap' }}>{val}</span>}>
                                <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{val}</span>
                            </Tooltip>
                        )
                        : '-'
                },
                {
                    dataIndex: 'success', key: 'success', title: t('Status'), sorter: true, width: 100,
                    render: (val, row) => val
                        ? <Tag color="success">{t('Sent')}</Tag>
                        : <Tooltip title={row.error}><Tag color="error">{t('Failed')}</Tag></Tooltip>
                },
                {
                    dataIndex: 'error', key: 'error', title: t('Error'), width: 220,
                    render: (val) => val
                        ? <Tooltip title={val}><span style={{ color: '#cf1322' }}>{val}</span></Tooltip>
                        : '-'
                },
                {
                    dataIndex: 'response', key: 'response', title: t('Provider Response'), width: 130, align: 'center',
                    render: (val, row) => (val || row.error)
                        ? <Button size="small" icon={<EyeOutlined />} onClick={() => setDetailRow(row)}>{t('View')}</Button>
                        : '-'
                },
            ]
        })
    }, [])

    const load = async () => {
        const res = await ApiService.SmsLog.GetSmsLogDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid />
            <Modal
                open={!!detailRow}
                title={t('Provider Response')}
                onCancel={() => setDetailRow(null)}
                footer={<Button onClick={() => setDetailRow(null)}>{t('Close')}</Button>}
                width={720}
            >
                {detailRow?.error && (
                    <>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('Error')}</div>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#cf1322', background: '#fff1f0', padding: 8, borderRadius: 4, marginBottom: 16 }}>
                            {detailRow.error}
                        </pre>
                    </>
                )}
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('Provider Response')}</div>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#f5f5f5', padding: 8, borderRadius: 4, maxHeight: 360, overflow: 'auto' }}>
                    {detailRow?.response || '-'}
                </pre>
            </Modal>
        </>
    )
}
